module.exports = __webpack_public_path__ + "assets/icons/yard-debris.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/jobcategories/yard-debris.png
// module id = ./src/styles/icons/jobcategories/yard-debris.png
// module chunks = 0